import ButtonComponent from '../../../../common-components/ButtonComponent/ButtonComponent';
import ModalComponent from '../../../../common-components/ModalComponent/ModalComponent';

import '../../styles/addon-modal.scss';

import Lottie from 'lottie-react';

import animationData from '../../../../../images/animations/confettiEffectAnimation.json';

export default function AddonSuccessModal({ show, onClose }) {
  return (
    <ModalComponent show={show} onClose={onClose} width={550}>
      <div className="addon-success-modal">
        <Lottie
          animationData={animationData}
          loop={true}
          style={{
            position: 'absolute',
            width: '350px',
            height: '350px',
            top: '0',
            pointerEvents: 'none',
          }}
        />
        <div style={{ fontSize: '60px' }}>🎉</div>
        <h2>
          Congratulations!
          <br />
          You got the PULSE Add-On
        </h2>
        <p>You will now be able to track posts and see how content impacts your brand.</p>
        <p>
          If you want to make the most of this, or need help,
          <br />
          <span
            style={{
              color: 'var(--saral-purple)',
              fontStyle: 'italic',
              textDecoration: 'underline',
            }}>
            book a strategy meeting.
          </span>
        </p>
        <br />
        <ButtonComponent style={{ width: '100%' }} onClick={onClose}>
          Let's get rolling!
        </ButtonComponent>
      </div>
    </ModalComponent>
  );
}
